import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @param {string} path path provided by react-router
 * @returns {string} normalizedPath path formatted
 */
export const formatPathname = (pathname: string) => {
  const pathnameArray = pathname.split('/');
  return pathnameArray[pathnameArray.length - 1];
};

/**
 * @param {string} path Path to include styling on
 * @param {string} className Tailwind classes
 * @returns void
 */
export const useBodyStyleOnPath = (path: string, className: string) => {
  const location = useLocation();
  const pathName = formatPathname(location.pathname);
  const isClassNamePopulated = className.trim() !== '';
  console.log({ pathName });
  useEffect(() => {
    if (pathName === path && isClassNamePopulated) {
      console.log(className, 'this runs');
      document.body.classList.add(className);
    } else if (isClassNamePopulated) {
      console.log('else statement');
      document.body.classList.remove(className);
    }
    return () => {
      console.log('clean-up');
      if (isClassNamePopulated) document.body.classList.remove(className);
    };
  }, [pathName, path, className]);
};
